export default {
    late: 'En retard',
    past: 'Passée',
    today: "Aujourd'hui",
    upcoming: 'À venir',
};
